module.exports = __webpack_public_path__ + "img/march 5 1965 minstrel article in collegiate times.7e3dcc8e.jpg";